import { Button } from '@vds/buttons';
import { convertStringToElements } from '@vds/html-parsers';
import { Icon } from '@vds/icons';
import { Modal, ModalBody, ModalFooter } from '@vds/modals';
import { Notification } from "@vds/notifications";
import { Tilelet } from "@vds/tiles";
import { Body } from '@vds/typography';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import CountryListModal from '../../shared/components/CountryListModal';
import PaygoRatesModal from '../../shared/components/PaygoRatesModal';
import { setModelTagging, dispatchNotifyEvent } from '../../shared/utils/tagging';
import { useNavigate } from 'react-router-dom';

const Space = styled.div`
padding-top: ${props => props.pt || 8}px;
`
const AvailableFeaturesDiv = styled.div`
display:flex;
margin-bottom:8px;
`

const StyledSpaceDiv = styled.div`
margin-left:4px;
`

const ReviewModal = ({ PlanData, showReviewModal, setReviewModal }) => {

    const navigate = useNavigate();
    const [showCountryListModal, setCountryListModal] = useState(false);
    const [showPaygoRatesModal, setPaygoRatesModal] = useState(false);

    // for only airplane case reviewdetail content will be outside planinfo 
    let reviewPageData = PlanData?.reviewDetailsModal ? PlanData.reviewDetailsModal : PlanData;
    let availableFeatures = PlanData?.availableFeatures;

    const handleButtonChange = () => {
        navigate(-1, { replace: true })
        setReviewModal(false)
    }
    const OnCountryClick = () => {
        setCountryListModal(true);

    }

    const OnPaygoRatesClick = () => {
        setPaygoRatesModal(true);

    }


    const onOpenedChange = value => {
        setModelTagging(`${PlanData.planName} Review Modal`, 'ReviewModal', value);
        if (!value) {
            navigate(-1, { replace: true })
            setReviewModal(false)
        }
    };
    useEffect(() => {
        if (reviewPageData?.notificationText) {
            dispatchNotifyEvent(reviewPageData?.notificationText, "99")
        }

    }, [])

    useEffect(() => {
        // setTimeout to check page load temporary
        setTimeout(() => {
            const countryClick = document.getElementById('210country');
            const paygoClick = document.getElementById('paygo');
            countryClick?.addEventListener('click', () => OnCountryClick());
            paygoClick?.addEventListener('click', () => OnPaygoRatesClick());
        }, 100)
    }, [])

    return (
        <>
            <Modal
                opened={showReviewModal}
                onOpenedChange={onOpenedChange}
                ariaLabel="Review Modal"
                id="ReviewModal"
            >
                <Tilelet
                    eyebrow={{
                        size: "bodyLarge",
                        children: reviewPageData?.title
                    }}
                    title={{
                        bold: true,
                        size: 'titleMedium',
                        children: reviewPageData?.planName
                    }}
                    subtitle={{
                        size: 'bodyLarge',
                        children: reviewPageData?.subText,
                        color: 'primary',
                    }}
                    surface='light'
                    width='100%'
                    height='40%'
                    backgroundColor='black'
                />
                <ModalBody>
                    {availableFeatures.map((feature, i) => {
                        return (
                            <AvailableFeaturesDiv>
                                <Icon
                                    name={feature?.icon}
                                    size="large"
                                    color="#000000"
                                />
                                <div style={{ paddingLeft: '20px' }}></div>

                                <Body size="small" bold><span dangerouslySetInnerHTML={{ __html: feature?.reviewText }}></span></Body>
                                <StyledSpaceDiv></StyledSpaceDiv>

                            </AvailableFeaturesDiv>)
                    })}
                    <Space pt={24} />
                    {reviewPageData?.notificationText &&
                        <Notification
                            type="error"
                            hideCloseButton="true"
                            title={reviewPageData?.notificationText}
                            fullBleed={false}
                            inline={false}
                            disableFocus={true}
                        />}
                    <Space pt={24} />
                    {reviewPageData?.faq.map((item, i) => {
                        return (
                            <>
                                <Body size="large" >{convertStringToElements(item.title)}</Body>
                                <Space />
                                <Body size="large">{convertStringToElements(item.description)}</Body>
                            </>)
                    })}
                    {reviewPageData?.disclaimerFooterText && <Body size="small">{convertStringToElements(reviewPageData?.disclaimerFooterText)}</Body>}
                </ModalBody>
                <ModalFooter>
                    <Space pt={24} />
                    <Button onClick={() => handleButtonChange()} size="large" width="100%" use="secondary" >{reviewPageData?.closeButtonText}</Button>
                </ModalFooter>
            </Modal>
            {showCountryListModal &&
                <CountryListModal
                    setCountryListModal={setCountryListModal}
                    isTravelPass = {reviewPageData?.planName == "TravelPass" ? true : false}
                />
            }

            {showPaygoRatesModal &&
                <PaygoRatesModal
                    setPaygoRatesModal={setPaygoRatesModal}
                />
            }
        </>
    );
}

export default ReviewModal;